"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCsrfTokenFromURI = exports.createCsrfToken = void 0;
const jsrsasign_1 = require("jsrsasign");
const atob = (function () {
    try {
        return window && window.atob;
    }
    catch (ex) {
        try {
            // @ts-ignore: We need to pick atob from global
            return global && global.atob;
        }
        catch (ex) {
            console.log("Unable to aquire atob from window or global");
            return null;
        }
    }
})();
const ALGORITHM = "HS256";
function createCsrfToken(base64Key, path) {
    const header = {
        alg: ALGORITHM,
        type: "JWT",
    };
    // payload
    const payload = {
        timestamp: jsrsasign_1.jws.IntDate.getNow() * 1000,
        url: path,
    };
    const sessionKey = atob(base64Key);
    return jsrsasign_1.jws.JWS.sign(ALGORITHM, JSON.stringify(header), JSON.stringify(payload), sessionKey);
}
exports.createCsrfToken = createCsrfToken;
function createCsrfTokenFromURI(base64Key, uri) {
    /* URI.path will return with a leading / */
    return createCsrfToken(base64Key, `${uri.protocol()}://${uri.host()}${uri.path()}`);
}
exports.createCsrfTokenFromURI = createCsrfTokenFromURI;
